import { render, staticRenderFns } from "./LandingBabyWunschlisteDE.vue?vue&type=template&id=d0057954"
import script from "./LandingBabyWunschlisteDE.vue?vue&type=script&lang=js"
export * from "./LandingBabyWunschlisteDE.vue?vue&type=script&lang=js"
import style0 from "./LandingBabyWunschlisteDE.vue?vue&type=style&index=0&id=d0057954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports